import React, { createContext, useContext, useMemo, useState } from 'react';

const CookieConsentContext = createContext(null);

export function CookieProvider({ children }) {
  const [showModal, setShowModal] = useState(false);

  const value = useMemo(() => ({
    showModal,
    openModal: () => setShowModal(true),
    closeModal: () => setShowModal(false),
  }), [showModal]);

  return <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>;
}

export function useCookie() {
  const context = useContext(CookieConsentContext);

  if (!context) {
    throw new Error('useCookie must be used within CookieProvider');
  }

  return context;
}
